import { render, staticRenderFns } from "./DetailsWap.vue?vue&type=template&id=fcb34262&scoped=true"
import script from "./DetailsWap.vue?vue&type=script&lang=js"
export * from "./DetailsWap.vue?vue&type=script&lang=js"
import style0 from "./DetailsWap.vue?vue&type=style&index=0&id=fcb34262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb34262",
  null
  
)

export default component.exports